import React from 'react';
import { DynamicFormBuilderContainer } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container';
import { FormItemTypes } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity';
import { Typography, useMediaQuery } from '@mui/material';
import { MuiStack } from '../../../components';
import { secondary } from '../../../theme/colors';
import { ChevronRightRounded, ExpandLessRounded } from '@mui/icons-material';
import { useAppDispatch } from '../../../store/hooks';
var GrandTotalPopup = function () {
    var IS_DESKTOP = useMediaQuery(function (theme) { return theme.breakpoints.up("md"); });
    var dispatch = useAppDispatch();
    var formData = [{
            type: FormItemTypes.ContainerItem,
            name: "",
            label: "",
            value: null,
            columnSize: 12,
            elements: [{
                    type: FormItemTypes.Box,
                    name: "",
                    columnSize: 12,
                    display: 'flex',
                    justifyContent: 'end',
                    sx: {
                        padding: '0px 16px 0px 16px',
                        marginBottom: '80px'
                    },
                    elements: [{
                            type: FormItemTypes.Button,
                            name: "GrandTotal",
                            label: "",
                            value: null,
                            md: 4,
                            lg: 4,
                            sm: 6,
                            xs: 12,
                            children: /*#__PURE__*/ React.createElement(Typography, {
                                sx: {
                                    flexGrow: 1
                                },
                                textAlign: "left",
                                fontSize: 'strong'
                            }, IS_DESKTOP ? /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(Typography, {
                                fontWeight: 'strong'
                            }, "Grand Total")) : /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(Typography, {
                                fontWeight: 'strong'
                            }, "\u20B9 00.0045"))),
                            variant: "outlined",
                            fullWidth: true,
                            sx: {
                                justifyContent: "space-between",
                                bgcolor: 'white',
                                fontWeight: "bold",
                                borderColor: secondary[200],
                                color: secondary[900]
                            },
                            setFieldProps: function (formValues, currValue) {
                                return {
                                    type: this.type,
                                    startIcon: IS_DESKTOP ? formValues !== null && formValues !== void 0 && formValues.Open ? /*#__PURE__*/ React.createElement(ExpandLessRounded, {
                                        sx: {
                                            color: secondary[600]
                                        }
                                    }) : /*#__PURE__*/ React.createElement(ChevronRightRounded, {
                                        sx: {
                                            color: secondary[600]
                                        }
                                    }) : /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(Typography, {
                                        fontWeight: 'strong'
                                    }, "G.T")),
                                    endIcon: IS_DESKTOP ? /*#__PURE__*/ React.createElement(Typography, null, "90.00") : formValues !== null && formValues !== void 0 && formValues.Open ? /*#__PURE__*/ React.createElement(ExpandLessRounded, {
                                        sx: {
                                            color: secondary[600]
                                        }
                                    }) : /*#__PURE__*/ React.createElement(ChevronRightRounded, {
                                        sx: {
                                            color: secondary[600]
                                        }
                                    })
                                };
                            },
                            setFormState: function (formValues, e, field) {
                                return {
                                    Open: !(formValues !== null && formValues !== void 0 && formValues.Open)
                                };
                            }
                            // onClick: clickOnGrandTotal
                        }]
                }]
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData,
        gridProps: {
            spacing: 0
        }
        // getFormAPI={getWorkDistributionList}
        // getKey={JobCardKeys.WorkDistributionList}
        // getRequest={{ request }}
        ,
        mode: "edit"
        // updateFormAPI={UpsertWorkDistribution}
        // updateRequest={{
        //     request: request?.jobCardId
        // }}
    }));
};
export default GrandTotalPopup;
